<template>
  <div class="Crisis_addmajor_event">
    <el-form style="padding-top: 20px;" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

      <el-form-item label="学生学号" prop="userId">
        <el-input :disabled="true" v-model="ruleForm.userId"></el-input>
      </el-form-item>

      <el-form-item label="学生姓名" prop="realName">
        <el-input :disabled="true" v-model="ruleForm.realName"></el-input>
      </el-form-item>


      <el-form-item label="预警人">
        <el-input :disabled="true" v-model="ruleForm.alertName"></el-input>
      </el-form-item>

      <el-form-item label="预警人电话">
        <el-input :disabled="true" v-model="ruleForm.alertPhone"></el-input>
      </el-form-item>

      <el-form-item label="自杀他杀风险详情" class="nkjs">
        <el-input :disabled="true" type="textarea" v-model="ruleForm.difficultDetail"></el-input>
      </el-form-item>

      <h2 style="font-size: 20px;margin-left: 20px;padding-bottom: 20px;">"五困"类型及具体表现</h2>

      <el-form-item class="difficulty" label="学习困扰">
        <el-checkbox-group :disabled="true" :max="3" style="position: relative;" v-model="ruleForm.studyDifficulty">
          <el-checkbox  label="1" name="type">学业基础薄弱</el-checkbox>
          <el-checkbox  label="2" name="type">学习能力差</el-checkbox>
          <el-checkbox  label="3" name="type">科研能力差</el-checkbox>
          <el-checkbox  label="4" name="type">缺乏专业兴趣</el-checkbox>
          <el-checkbox  label="5" name="type">第一次挂科</el-checkbox>
          <el-checkbox  label="6" name="type">多门挂科</el-checkbox>
          <el-checkbox  label="7" name="type">缺课缺考</el-checkbox>
          <el-checkbox  label="8" name="type">留级延期</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right:30px;display: block;color: #606266;">其他</span>
        <el-input style="width: 200px;position: absolute;top: 2px;right: -10px;" v-model="studyDifficultyOther" placeholder="请输入学习困扰"></el-input>
      </el-form-item>

      <el-form-item class="difficulty" label="生活困扰">
        <el-checkbox-group :disabled="true" :max="3" style="position: relative;" v-model="ruleForm.lifeDifficulty">
          <el-checkbox label="1" name="type">经济困难</el-checkbox>
          <el-checkbox label="2" name="type">未获助学贷款</el-checkbox>
          <el-checkbox label="3" name="type">家庭重大变故</el-checkbox>
          <el-checkbox label="4" name="type">严重躯体疾病</el-checkbox>
          <el-checkbox label="5" name="type">生活自理困难</el-checkbox>
          <el-checkbox label="6" name="type">身体缺陷</el-checkbox>
          <el-checkbox label="7" name="type">语言困难</el-checkbox>
          <el-checkbox label="8" name="type">被骗被控制</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right:0px;display: block;color: #606266;">其他</span>
        <el-input style="width: 200px;position: absolute;top: 2px;right: -40px;" v-model="lifeDifficultyOther" placeholder="请输入生活困难"></el-input>
      </el-form-item>
      <el-form-item class="difficulty" label="交往困扰">
        <el-checkbox-group :disabled="true" :max="3" style="position: relative;" v-model="ruleForm.contactDifficulty">
          <el-checkbox label="1" name="type">内向孤僻</el-checkbox>
          <el-checkbox label="2" name="type">退缩回避</el-checkbox>
          <el-checkbox label="3" name="type">适应不良</el-checkbox>
          <el-checkbox label="4" name="type">同学关系不良</el-checkbox>
          <el-checkbox label="5" name="type">师生关系不良</el-checkbox>
          <el-checkbox label="6" name="type">亲密关系不良</el-checkbox>
          <el-checkbox label="7" name="type">家庭关系不良</el-checkbox>
          <el-checkbox label="8" name="type">遭遇欺凌等</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right:0px;display: block;color: #606266;">其他</span>
        <el-input v-model="contactDifficultyOther" style="width: 200px;position: absolute;top: 2px;right: -40px;" placeholder="请输入交往困难"></el-input>
      </el-form-item>

      <el-form-item class="difficulty" label="发展困扰">
        <el-checkbox-group :disabled="true" :max="3" style="position: relative;" v-model="ruleForm.developDifficulty">
          <el-checkbox label="1" name="type">深感自卑</el-checkbox>
          <el-checkbox label="2" name="type">思想偏激</el-checkbox>
          <el-checkbox label="3" name="type">发展迷茫</el-checkbox>
          <el-checkbox label="4" name="type">过高期待</el-checkbox>
          <el-checkbox label="5" name="type">毕业困难</el-checkbox>
          <el-checkbox label="6" name="type">考研失败</el-checkbox>
          <el-checkbox label="7" name="type">就业困难</el-checkbox>
          <el-checkbox label="8" name="type">创业失败</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right:130px;display: block;color: #606266;">其他</span>
        <el-input v-model="developDifficultyOther" style="width: 200px;position: absolute;top: 2px;right: 90px;" placeholder="请输入发展困难"></el-input>
      </el-form-item>

      <el-form-item class="difficulty" label="心理困扰">
        <el-checkbox-group :disabled="true" :max="3" style="position: relative;" v-model="ruleForm.psyDifficulty">
          <el-checkbox label="1" name="type">自杀伤人倾向</el-checkbox>
          <el-checkbox label="2" name="type">重性精神病</el-checkbox>
          <el-checkbox label="3" name="type">应激危机</el-checkbox>
          <el-checkbox label="4" name="type">人格问题</el-checkbox>
          <el-checkbox label="5" name="type">情绪障碍</el-checkbox>
          <el-checkbox label="6" name="type">成瘾行为</el-checkbox>
          <el-checkbox label="7" name="type">进食问题</el-checkbox>
          <el-checkbox label="8" name="type">睡眠问题</el-checkbox>
        </el-checkbox-group>
        <span style="width: 200px;position: absolute;top: 0px;right:80px;display: block;color: #606266;">其他</span>
        <el-input v-model="psyDifficultyOther" style="width: 200px;position: absolute;top: 2px;right: 40px;" placeholder="请输入心理困难"></el-input>
      </el-form-item>

      <h2 style="font-size: 20px;margin-left: 20px;padding-bottom: 20px;">发现途径</h2>

      <el-form-item class="quz">
        <el-checkbox-group :disabled="true" :max="3" v-model="ruleForm.discovery">
          <el-checkbox label="1"  name="type">学生本人</el-checkbox>
          <el-checkbox label="2"  name="type">家人配偶</el-checkbox>
          <el-checkbox label="3"  name="type">其他亲属</el-checkbox>
          <el-checkbox label="4"  name="type">同学</el-checkbox>
          <el-checkbox label="5"  name="type">朋友</el-checkbox>
          <el-checkbox label="6"  name="type">心理委员</el-checkbox>
          <el-checkbox label="7"  name="type">心理联络员</el-checkbox>
          <el-checkbox label="8"  name="type">心理辅导员</el-checkbox>
          <el-checkbox label="9"  name="type">辅导员</el-checkbox>
          <el-checkbox label="10" name="type">班主任</el-checkbox>
          <el-checkbox label="11" name="type">心理中心</el-checkbox>
          <el-checkbox label="12" name="type">授课教师</el-checkbox>
          <el-checkbox label="13" name="type">导师</el-checkbox>
          <el-checkbox label="14" name="type">其他校内人员</el-checkbox>
          <el-checkbox label="15" name="type">其他校外人员</el-checkbox>
          <el-checkbox label="16" name="type">微信微博QQ</el-checkbox>
          <el-checkbox label="17" name="type">电话短信邮件</el-checkbox>
          <el-checkbox label="18" name="type">书面</el-checkbox>
          <el-checkbox label="19" name="type">当面交流</el-checkbox>
          <el-checkbox label="20" name="type">其他</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <h2 style="font-size: 20px;margin-left: 20px;padding-bottom: 20px;">问题备注及应对工作（ <i style="color: red;">*</i> 为必填项）</h2>

      <el-form-item  class="bgfbf" label="初评危机状态">
        <el-radio  v-model="ruleForm.firstCrisis" label="1">红色预警</el-radio>
        <el-radio  v-model="ruleForm.firstCrisis" label="2">橙色预警</el-radio>
        <el-radio  v-model="ruleForm.firstCrisis" label="3">黄色预警</el-radio>
        <el-radio  v-model="ruleForm.firstCrisis" label="4">蓝色预警</el-radio>
        <el-radio  v-model="ruleForm.firstCrisis" label="5">绿色预警</el-radio>
        <el-radio  v-model="ruleForm.firstCrisis" label="6">无法确定</el-radio>
      </el-form-item>

      <!-- <el-form-item class="hjoi" label="严重情况突出表现" prop="tubx">
        <el-checkbox-group @change="tcbx()" v-model="ruleForm.tubx">
          <el-checkbox label="自杀、自伤或伤害他人倾向" name="type"></el-checkbox>
          <el-checkbox label="疑似重性精神病" name="type"></el-checkbox>
        </el-checkbox-group>
      </el-form-item> -->

      <el-form-item class="suicidalFlg" label="自杀、自伤或伤害他人倾向">
        <el-radio @change="tcbx()" v-model="ruleForm.suicidalFlg" label="1">是</el-radio>
        <el-radio @change="tcbx()" v-model="ruleForm.suicidalFlg" label="2">否</el-radio>
      </el-form-item>

      <div v-if="pdtcbx">

        <el-form-item label="发生时间">
          <el-date-picker v-model="ruleForm.suicidalDate"  type="date" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
        </el-form-item>

        <el-form-item label="发生情况" class="nkjs">
          <el-input type="textarea" v-model="ruleForm.suicidalDetail"></el-input>
        </el-form-item>

        <el-form-item class="bgfbf" label="关于伤害的情况">
          <el-checkbox-group :max="3" v-model="ruleForm.damage">
            <el-checkbox label="1" name="type">自杀想法</el-checkbox>
            <el-checkbox label="2" name="type">自杀计划</el-checkbox>
            <el-checkbox label="3" name="type">自杀未遂</el-checkbox>
            <el-checkbox label="4" name="type">自杀实施中</el-checkbox>
            <el-checkbox label="5" name="type">自杀姿态</el-checkbox>
            <el-checkbox label="6" name="type">被动自杀</el-checkbox>
            <el-checkbox label="7" name="type">自伤自残</el-checkbox>
            <el-checkbox label="8" name="type">伤害他人</el-checkbox>
            <el-checkbox label="9" name="type">扩大性自杀</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item class="InjuryDetails nkjs" label="（务必详细描述时间、情况、进展等）">
          <el-input type="textarea" v-model="ruleForm.damageDetail"></el-input>
        </el-form-item>

      </div>

      <el-form-item class="psychosesFlg" label="疑似重性精神障碍">
        <el-radio  @change="tcbx()" v-model="ruleForm.psychosesFlg" label="1">是</el-radio>
        <el-radio  @change="tcbx()" v-model="ruleForm.psychosesFlg" label="2">否</el-radio>
      </el-form-item>

      <div v-if="pdtcbx2">
        <el-form-item label="发生时间">
          <el-date-picker v-model="ruleForm.psychosesDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>

        <el-form-item label="发生情况" class="nkjs">
          <el-input type="textarea" v-model="ruleForm.psychosesDetail"></el-input>
        </el-form-item>

        <el-form-item class="bgfbf" label="疑似出现">
          <el-checkbox-group :max="3" v-model="ruleForm.suspectedAppear">
            <el-checkbox label="1"  name="type">感知觉障碍</el-checkbox>
            <el-checkbox label="2"  name="type">思维障碍</el-checkbox>
            <el-checkbox label="3"  name="type">注意障碍</el-checkbox>
            <el-checkbox label="4"  name="type">记忆障碍</el-checkbox>
            <el-checkbox label="5"  name="type">定向力障碍</el-checkbox>
            <el-checkbox label="6"  name="type">情感障碍</el-checkbox>.
            <el-checkbox label="7"  name="type">意志障碍</el-checkbox>
            <el-checkbox label="8"  name="type">动作与行为障碍</el-checkbox>
            <el-checkbox label="9"  name="type">意识障碍</el-checkbox>
            <el-checkbox label="10" name="type">自知力缺失</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </div>

      <el-form-item class="bgssfbf" label="心理辅导员与该生谈话情况/直接接触情况/深度情况/以往了解情况日期">
        <el-date-picker v-model="ruleForm.appearDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
      </el-form-item>

      <el-form-item label="地点">
        <el-input v-model="ruleForm.appearAddress"></el-input>
      </el-form-item>

      <el-form-item label="主要内容" class="nkjs">
        <el-input type="textarea" v-model="ruleForm.appearDetail"></el-input>
      </el-form-item>

      <el-form-item label="上报领导">
        <el-radio v-model="ruleForm.reportLeaderFlg" label="1">是</el-radio>
        <el-radio v-model="ruleForm.reportLeaderFlg" label="2">否</el-radio>
      </el-form-item>

      <el-form-item label="详情" class="nkjs">
        <el-input type="textarea" v-model="ruleForm.reportLeaderDetail"></el-input>
      </el-form-item>

      <el-form-item label="与家长沟通">
        <el-radio v-model="ruleForm.parentFlg" label="1">是</el-radio>
        <el-radio v-model="ruleForm.parentFlg" label="2">否</el-radio>
      </el-form-item>

      <el-form-item label="详情" class="nkjs">
        <el-input type="textarea" v-model="ruleForm.parentDetail"></el-input>
      </el-form-item>

      <el-form-item label="就医情况">
        <el-radio v-model="ruleForm.hospitalFlg" label="1">是</el-radio>
        <el-radio v-model="ruleForm.hospitalFlg" label="2">否</el-radio>
      </el-form-item>

      <el-form-item label="医院">
        <el-input v-model="ruleForm.hospitalName"></el-input>
      </el-form-item>

      <el-form-item label="诊断结果" class="nkjs">
        <el-input type="textarea" v-model="ruleForm.hospitalDetail"></el-input>
      </el-form-item>
      
      <el-form-item label="服药情况">
        <el-radio v-model="ruleForm.medicineFlg" label="1">是</el-radio>
        <el-radio v-model="ruleForm.medicineFlg" label="2">否</el-radio>
      </el-form-item>

      <el-form-item class="p1" label="是否在心理中心咨询">
        <el-radio @change="tcbx()" v-model="ruleForm.counsultFlg" label="1">是</el-radio>
        <el-radio @change="tcbx()" v-model="ruleForm.counsultFlg" label="2">否</el-radio>
      </el-form-item>

      <div v-if="pdtcbx9">
        <el-form-item class="p2" label="咨询开始时间">
          <el-date-picker v-model="ruleForm.counsultBegin" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"> </el-date-picker>
        </el-form-item>
        <el-form-item label="咨询次数">
          <el-input v-model="ruleForm.counsultTimes"></el-input>
        </el-form-item>
      </div>

      <div v-else>
        <el-form-item class="p3" label="推荐去心理中心">
          <el-radio v-model="ruleForm.recommendCounsultFlg" label="1">是</el-radio>
          <el-radio v-model="ruleForm.recommendCounsultFlg" label="2">否</el-radio>
        </el-form-item>

        <el-form-item class="p4" label="后续实际是否去了">
          <el-radio v-model="ruleForm.realityCounsultFlg" label="1">是</el-radio>
          <el-radio v-model="ruleForm.realityCounsultFlg" label="2">否</el-radio>
        </el-form-item>
      </div>

      <el-form-item class="p5 nkjs" label="心理联络员配合工作情况" >
        <el-input type="textarea" v-model="ruleForm.contactWorkDetail"></el-input>
      </el-form-item>

      <el-form-item class="p6 nkjs" label="心理委员配合工作情况">
        <el-input type="textarea" v-model="ruleForm.committWorkDetail"></el-input>
      </el-form-item>

      <el-form-item class="p7" label="与（部门）老师联系">
        <el-input v-model="ruleForm.contactDeptName"></el-input>
      </el-form-item>

      <el-form-item label="为该生" class="nkjs">
        <el-input type="textarea" v-model="ruleForm.otherTeacherDetail"></el-input>
      </el-form-item>

      <el-form-item label="多方会谈">
        <el-radio v-model="ruleForm.multiPartyFlg" label="1">需要</el-radio>
        <el-radio v-model="ruleForm.multiPartyFlg" label="2">不需要</el-radio>
      </el-form-item>

      <el-form-item class="bgfbf" label="心理中心建议" style="padding-bottom: 20px;" prop="psychCentralSuggest">
        <el-checkbox-group :max="3" v-model="ruleForm.psychCentralSuggest">
          <el-checkbox label="1"  name="type">精神专科就医</el-checkbox>
          <el-checkbox label="2"  name="type">心理咨询</el-checkbox>
          <el-checkbox label="3"  name="type">心理危机干预</el-checkbox>
          <el-checkbox label="4"  name="type">保密突破联系监护人</el-checkbox>
          <el-checkbox label="5"  name="type">报警急救</el-checkbox>
          <el-checkbox label="6"  name="type">严密守护</el-checkbox>
          <el-checkbox label="7"  name="type">密切陪护</el-checkbox>
          <el-checkbox label="8"  name="type">重点关注</el-checkbox>
          <el-checkbox label="9"  name="type">适当关注</el-checkbox>
          <el-checkbox label="10" name="type">绿色预警交流</el-checkbox>
          <el-checkbox label="11" name="type">其他</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <!-- <div v-if="RoleID == 1069 || RoleID == 1068 || RoleID == 1070" style="padding-bottom: 20px;"> -->
      <!-- <div style="padding-bottom: 20px;">
        <el-form-item class="bgfbf2" label="辅导员初核意见" style="padding-bottom: 20px;" v-if="(liroleID == '1079' && reportStatus == '辅导员审核驳回') || (this.Global.pdroleid(1068) || this.Global.pdroleid(1070) || this.Global.pdroleid(1069) || this.Global.pdroleid(1063))">
          <el-checkbox-group :disabled="true" :max="3" v-model="shenhe.counsellorChecks">
            <el-checkbox label="1" name="type">信息不完整</el-checkbox>
            <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
            <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
            <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item class="nkjs">
          <el-input :disabled="true" type="textarea" v-model="shenhe.counsellorCheckDetail"></el-input>
        </el-form-item>
      </div> -->

        <div style="padding-bottom: 20px;" v-if="(this.Global.pdroleid(1068) || this.Global.pdroleid(1070) || this.Global.pdroleid(1069)) || (reportStatus == '风险监控员审核驳回' && (this.Global.pdroleid(1063) || this.Global.pdroleid(1089)))">
          <el-form-item class="bgfbf2" label="风险监控员初核意见" style="padding-bottom: 20px;">
            <el-checkbox-group :disabled="true" :max="3" v-model="shenhe.riskMonitorChecks">
              <el-checkbox label="1" name="type">信息不完整</el-checkbox>
              <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
              <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
              <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="nkjs">
            <el-input :disabled="true" type="textarea" v-model="shenhe.riskMonitorCheckDetail"></el-input>
          </el-form-item>
        </div>

        <div v-if="this.Global.pdroleid(1068) || this.Global.pdroleid(1070)">
          <el-form-item class="bgfbf2" label="危机主管复核意见" style="padding-bottom: 20px;">
            <el-checkbox-group :disabled="true" :max="3" v-model="shenhe.criAdminChecks">
              <el-checkbox label="1" name="type">信息不完整</el-checkbox>
              <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
              <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
              <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="nkjs">
            <el-input :disabled="true" type="textarea" v-model="shenhe.criAdminCheckDetail"></el-input>
          </el-form-item>
        </div>

        <div v-if="this.Global.pdroleid(1068) || this.Global.pdroleid(1070)">
          <el-form-item class="bgfbf2" label="中心主任审核意见" style="padding-bottom: 20px;">
            <el-checkbox-group :disabled="true" :max="3" v-model="shenhe.centerDirectorChecks">
              <el-checkbox label="1" name="type">信息不完整</el-checkbox>
              <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
              <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
              <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="nkjs">
            <el-input :disabled="true" type="textarea" v-model="shenhe.centerDirectorCheckDetail"></el-input>
          </el-form-item>
        </div>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">立即修改</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>
<script>

export default {
  data() {
    return {
      liroleID:'',
      RoleID: '',
      taizhuangpd:false,
      reportStatus:'',//上报状态
      shenhe: {
        riskMonitorChecks: [],//风险监控员审核意见
        riskMonitorCheckDetail: '',//风险监控员审核详细意见
        criAdminChecks: [],//危机主管审核意见
        criAdminCheckDetail: '',//危机主管审核详细意见
        centerDirectorChecks: [],//中心主任审核意见
        centerDirectorCheckDetail: '',//中心主任审核详细意见"
        counsellorChecks: '',//"
        counsellorCheckDetail: '',//"
      },
      KeyNo: '',
      pdtcbx: true,
      pdtcbx2: true,
      pdtcbx9: true,//是否在心理中心咨询
      radio: '1',
      lifeDifficultyOther: '',
      studyDifficultyOther: '',
      contactDifficultyOther: '',
      developDifficultyOther: '',
      psyDifficultyOther: '',
      ruleForm: {
        difficultDetail: '',//预警人
        alertName: '',//预警人
        alertPhone: '',//预警人电话
        userId: '',//学生学号
        realName: '', //学生姓名
        studyDifficulty: [],//学生困难
        lifeDifficulty: [],//生活困难
        contactDifficulty: [], //交往困难
        developDifficulty: [],//发展困难
        psyDifficulty: [],//心理困难
        discovery: [],//发展途径
        firstCrisis: '1',//初评危机状态
        suicidalFlg: '1',//伤害倾向
        suicidalDate: '',//伤害倾向发生时间
        suicidalDetail: '',//发生情况
        damage: [],//伤害发生情况
        damageDetail: '',//（务必详细描述时间、情况、进展等）
        psychosesFlg: '1',//重性精神病
        psychosesDate: '',//重性精神病发生时间
        psychosesDetail : '',//重性精神病发生情况
        suspectedAppear: [],//重性精神病疑似出现
        appearDate: '',//心理辅导员与该生谈话情况/直接接触情况/深度情况/以往了解情况日期
        appearAddress: '',//心理辅导员与该生谈话情况/直接接触情况/深度情况/以往了解情况地点
        appearDetail: '',//心理辅导员与该生谈话情况/直接接触情况/深度情况/以往了解情况详情
        reportLeaderFlg: '1',//上报领导情况 -->1.是 2.否
        reportLeaderDetail: '',//上报领导详情
        parentFlg: '1',//与家长沟通情况 -->1.是 2.否
        parentDetail: '',//与家长沟通详情
        hospitalFlg: '1',//就医情况 -->1.是 2.否
        hospitalName: '',//医院名称
        hospitalDetail: '',//就医详情
        medicineFlg: '1',//服药情况
        recommendCounsultFlg: '',//是否推荐咨询-->1.是 2.否
        realityCounsultFlg: '',//实际是否参与咨询
        contactWorkDetail: '',//心理联络员配合工作情况
        counsultFlg: '1', //是否在心理中心咨询,
        counsultBegin: '', //咨询开始时间
        counsultTimes: '', //咨询次数
        recommendCounsultFlg: "1",//是否推荐咨询-->1.是 2.否
        realityCounsultFlg: "1",//实际是否参与咨询
        contactWorkDetail: "",//心理联络员配合工作情况
        committWorkDetail: "",//心理委员配合工作情况
        contactDeptName: "",//对接其他部门名称
        otherTeacherDetail: "",//通过其他部门老师了解情况
        multiPartyFlg : "1",//多方会商是否需要 -->1.需要 2.不需要
        psychCentralSuggest: [],//心理中心建议
        type:1,
        keyNo:[this.$route.query.KeyNo][0],
      },
      rules: {
        userId: [
          { required: true, message: '请输入学生学号', trigger: 'blur' },
        ],
        realName: [
          { required: true, message: '请输入学生姓名', trigger: 'blur' },
        ],
        psychCentralSuggest: [
          { type: 'array', required: true, message: '请至少选择一个心理中心建议', trigger: 'change' }
        ],
      }
    };
  },
  methods: {
    Submit_account() {//提交台账
      this.$Http_Post('/DistressPrediction/CrisisLedger', { keyNo: this.KeyNo[0], operate:'1', userId: [this.$route.query.userId][0] }).then((res) => {
        if (res.Code == 200 || res.Code == 0 && res.Data) {
          this.Global.request_successful(res.Message);
          this.$router.push({path: '/Crisis/Crisis_upreport'})
        }else{
          this.Global.request_failure(res.Message)
        }
      });
    },
    tcbx() {
      if (this.ruleForm.suicidalFlg == 1) {
        this.pdtcbx = true;
      } else {
        this.pdtcbx = false;
      }
      if (this.ruleForm.psychosesFlg == 1) {
        this.pdtcbx2 = true;
      } else {
        this.pdtcbx2 = false;
      }
      if (this.ruleForm.counsultFlg == 1) {
        this.pdtcbx9 = true;
      } else {
        this.pdtcbx9 = false;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$Http_Post('/DistressPrediction/MakeCrisisParameter', { form: this.ruleForm ,type:1}).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.$router.push({
                path: '/Crisis/Crisis_upreport',
              })
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted() {
    this.KeyNo = [this.$route.query.KeyNo];
    this.RoleID = sessionStorage.getItem('RoleID');
    this.reportStatus = [this.$route.query.reportStatus][0];
    if (this.reportStatus == '待上报' && (this.Global.pdroleid(1063) || this.Global.pdroleid(1079) || this.Global.pdroleid(1089))) {
      this.taizhuangpd = true;
    }
    this.$Http_Post('/DistressPrediction/PrefabricatedTableData', {keyNo: this.KeyNo[0]}).then((res) => {
      if (res.Code == 0) {
        this.liroleID = res.Data.roleID;
        this.ruleForm = {
          difficultDetail: res.Data.difficultDetail,//预警人
          alertName: res.Data.alertName,//预警人
          alertPhone: res.Data.alertPhone,//预警人电话
          userId: res.Data.userId,//学生学号
          realName: res.Data.realName,//学生姓名
          discovery: res.Data.discoverys,//发展途径
          firstCrisis: res.Data.firstCrisis,//初评危机状态
          suicidalFlg: res.Data.suicidalFlg.toString(),//伤害倾向
          suicidalDate: res.Data.suicidalDate,//伤害倾向发生时间
          suicidalDetail: res.Data.suicidalDetail,//伤害倾向发生时间
          damage: res.Data.damages,//伤害发生情况
          damageDetail: res.Data.damageDetail,//（务必详细描述时间、情况、进展等）
          psychosesFlg: res.Data.psychosesFlg.toString(),//重性精神病
          psychosesDate: res.Data.psychosesDate,//重性精神病发生时间
          psychosesDetail: res.Data.psychosesDetail,//重性精神病发生情况
          suspectedAppear: res.Data.suspectedAppears,//重性精神病疑似出现
          appearDate: res.Data.appearDate,//心理辅导员与该生谈话情况/直接接触情况/深度情况/以往了解情况日期
          appearAddress: res.Data.appearAddress,//心理辅导员与该生谈话情况/直接接触情况/深度情况/以往了解情况地点
          appearDetail: res.Data.appearDetail,//心理辅导员与该生谈话情况/直接接触情况/深度情况/以往了解情况详情
          reportLeaderFlg: res.Data.reportLeaderFlg.toString(),//上报领导情况 -->1.是 2.否
          reportLeaderDetail: res.Data.reportLeaderDetail,//上报领导详情
          parentFlg: res.Data.parentFlg.toString(),//与家长沟通情况 -->1.是 2.否
          parentDetail: res.Data.parentDetail,//与家长沟通详情
          hospitalFlg: res.Data.hospitalFlg.toString(),//就医情况 -->1.是 2.否
          hospitalName: res.Data.hospitalName,//医院名称
          hospitalDetail: res.Data.hospitalDetail,//就医详情
          medicineFlg: res.Data.medicineFlg.toString(),//服药情况
          recommendCounsultFlg: res.Data.recommendCounsultFlg,//是否推荐咨询-->1.是 2.否
          realityCounsultFlg: res.Data.realityCounsultFlg,//实际是否参与咨询
          contactWorkDetail: res.Data.contactWorkDetail,//心理联络员配合工作情况
          counsultFlg: res.Data.counsultFlg.toString(), //是否在心理中心咨询,
          counsultBegin: res.Data.counsultBegin, //咨询开始时间
          counsultTimes: res.Data.counsultTimes, //咨询次数
          recommendCounsultFlg: res.Data.recommendCounsultFlg,//是否推荐咨询-->1.是 2.否
          realityCounsultFlg: res.Data.realityCounsultFlg,//实际是否参与咨询
          contactWorkDetail: res.Data.contactWorkDetail,//心理联络员配合工作情况
          committWorkDetail: res.Data.committWorkDetail,//心理委员配合工作情况
          contactDeptName: res.Data.contactDeptName,//对接其他部门名称
          otherTeacherDetail: res.Data.otherTeacherDetail,//通过其他部门老师了解情况
          multiPartyFlg: res.Data.multiPartyFlg.toString(),//多方会商是否需要 -->1.需要 2.不需要
          psychCentralSuggest: res.Data.psychCentralSuggests,//心理中心建议
          type:1,
          keyNo:[this.$route.query.KeyNo][0],
        }
        this.shenhe = {
          riskMonitorChecks: res.Data.riskMonitorChecks,//风险监控员审核意见
          riskMonitorCheckDetail: res.Data.riskMonitorCheckDetail,//风险监控员审核详细意见
          criAdminChecks: res.Data.criAdminChecks,//危机主管审核意见
          criAdminCheckDetail: res.Data.criAdminCheckDetail,//危机主管审核详细意见
          centerDirectorChecks: res.Data.centerDirectorChecks,//中心主任审核意见
          centerDirectorCheckDetail: res.Data.centerDirectorCheckDetail,//中心主任审核详细意见"
          counsellorChecks: res.Data.counsellorChecks,//"
          counsellorCheckDetail: res.Data.counsellorCheckDetail,//"
        }
        for (let i = 0; i <= res.Data.studyDifficultys.length; i++) {
          this.studyDifficultyOther = res.Data.studyDifficultyOther;
          this.ruleForm.studyDifficulty = res.Data.studyDifficultys;
        }
        for (let i = 0; i <= res.Data.lifeDifficultys.length; i++) {
          this.lifeDifficultyOther = res.Data.lifeDifficultyOther;
          this.ruleForm.lifeDifficulty = res.Data.lifeDifficultys;
        }
        for (let i = 0; i <= res.Data.contactDifficultys.length; i++) {
          this.contactDifficultyOther = res.Data.contactDifficultyOther;
          this.ruleForm.contactDifficulty = res.Data.contactDifficultys;
        }
        for (let i = 0; i <= res.Data.developDifficultys.length; i++) {
          this.developDifficultyOther = res.Data.developDifficultyOther;
          this.ruleForm.developDifficulty = res.Data.developDifficultys;
        }
        for (let i = 0; i <= res.Data.psyDifficultys.length; i++) {
          this.psyDifficultyOther = res.Data.psyDifficultyOther;
          this.ruleForm.psyDifficulty = res.Data.psyDifficultys;
        }
      }
    });
  }
}
</script>

<style>
  .Crisis_addmajor_event  {width: 100%;background-color: rgb(255, 255, 255);overflow: auto;}
  .Crisis_addmajor_event .el-input{width: 240px;}
  .Crisis_addmajor_event .quz .el-form-item__content{margin-left: 20px !important;}
  .Crisis_addmajor_event .bgfbf .el-form-item__label{width: 150px !important;}
  .Crisis_addmajor_event .hjoi .el-form-item__label{width: 180px !important;}
  .Crisis_addmajor_event .bgssfbf .el-form-item__label{width: 492px !important;}
  .Crisis_addmajor_event .huhxs .el-form-item__label{width: 172px !important;}
  .Crisis_addmajor_event .huhxsxs .el-form-item__label{width: 160px !important;}
  .Crisis_addmajor_event .aaa1 .el-form-item__label{width: 206px !important;}
  .Crisis_addmajor_event .aaa2 .el-form-item__label{width: 206px !important;}
  .Crisis_addmajor_event .aaa1 .el-form-item__content{margin-left: 210px !important;}
  .Crisis_addmajor_event .aaa2 .el-form-item__content{margin-left: 210px !important;}
  .Crisis_addmajor_event .suicidalFlg .el-form-item__label{width: 210px !important;}
  .Crisis_addmajor_event .psychosesFlg .el-form-item__label{width: 160px !important;}
  .Crisis_addmajor_event .InjuryDetails .el-form-item__label{width: 275px !important;}
  .Crisis_addmajor_event .InjuryDetails .el-textarea{margin-left: 13px !important;}
  .Crisis_addmajor_event .p1 .el-form-item__label{width: 170px !important;}
  .Crisis_addmajor_event .p2 .el-form-item__label{width: 130px !important;}
  .Crisis_addmajor_event .p3 .el-form-item__label{width: 142px !important;}
  .Crisis_addmajor_event .p4 .el-form-item__label{width: 156px !important;}
  .Crisis_addmajor_event .p5 .el-form-item__label{width: 200px !important;}
  .Crisis_addmajor_event .p5  .el-textarea{margin-left: -66px !important; width: 400px !important;}
  /* .Crisis_addmajor_event  .el-textarea{width: 500px !important;} */
  .Crisis_addmajor_event .p6 .el-form-item__label{width: 186px !important;}
  .Crisis_addmajor_event .p6  .el-textarea{margin-left: -66px !important;}
  .Crisis_addmajor_event .p7 .el-form-item__label{width: 176px !important;}
  .Crisis_addmajor_event .difficulty{width: 1400px !important;}
  .Crisis_addmajor_event .nkjs .el-textarea.is-disabled .el-textarea__inner{width: 500px !important;height: 80px;}
</style>